import { ReduxStore } from 'store/types';

function markThreadMessageAsOpenIsLoading(state: ReduxStore): boolean {
  return state.intervention.markThreadMessageAsOpen.config.isLoading;
}

export default markThreadMessageAsOpenIsLoading;
